






































































































































import Vue from "vue";
import Component from "vue-class-component";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import func from "@/ts/FormFunctions";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { IRecyclingFacilityApplicationVueModel } from "@/ts/models/IRecyclingFacilityApplicationVueModel";

@Component({
    props: {
        form: {
            type: Object as () => IRecyclingFacilityApplicationVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class RecyclingFacilityViolations extends Vue {
    name: string = "RecyclingFacilityViolations";
    title: string = "";
    index: number = NaN;

    errorMsgs = ErrorMessages;

    mounted(): void {
        this.initializeComponent("Violations");
    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        if (this.$props.vueStates.views[this.index].visited == false && this.$props.form.status == "Created") {
            this.$props.form.hasPollutionWasteViolations = this.$props.form.hasPollutionWasteViolations == null ? null : this.$props.form.hasPollutionWasteViolations;
            this.$props.form.hasPermitRevocations = this.$props.form.hasPermitRevocations == null ? null : this.$props.form.hasPermitRevocations;
            this.$props.form.hasUnpaidFees = this.$props.form.hasUnpaidFees == null ? null : this.$props.form.hasUnpaidFees;
        } else {
            this.$props.form.hasPollutionWasteViolations = this.$props.form.hasPollutionWasteViolations.toString();
            this.$props.form.hasPermitRevocations = this.$props.form.hasPermitRevocations.toString();
            this.$props.form.hasUnpaidFees = this.$props.form.hasUnpaidFees.toString();
        }

        this.$props.vueStates.views[this.index].visited = true;
    }

    get isPollutionWasteError(): boolean {
        return (func.isNullOrEmpty(this.$props.form.hasPollutionWasteViolations) || this.$props.form.hasPollutionWasteViolations === null || this.$props.form.hasPollutionWasteViolations == "null") || (this.$props.form.hasPollutionWasteViolations === "true" && func.isNullOrEmpty(this.$props.form.pollutionWasteDescription));
    }

    get isPermitRevocationError(): boolean {
        return (func.isNullOrEmpty(this.$props.form.hasPermitRevocations) || this.$props.form.hasPermitRevocations === null || this.$props.form.hasPermitRevocations == "null") || (this.$props.form.hasPermitRevocations === "true" && func.isNullOrEmpty(this.$props.form.permitRevocationDescription));
    }

    get isUnpaidFeesError(): boolean {
        return (func.isNullOrEmpty(this.$props.form.hasUnpaidFees) || this.$props.form.hasUnpaidFees === null || this.$props.form.hasUnpaidFees == "null") || (this.$props.form.hasUnpaidFees === "true" && func.isNullOrEmpty(this.$props.form.unpaidFeesDescription));
    }

    get hasErrors(): boolean {
        return this.isPollutionWasteError || this.isPermitRevocationError || this.isUnpaidFeesError;
    }
}
